import type { Response } from '~/types/api/v2'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const responseDataTypeName = 'recommendation'

export type RecommendationData = App.Data.Recommendation.CreateContractRecommendationData
interface Meta { // The use of meta like this is an exception in the backend.
  meta?: {
    reason?: 'no-finalized-contracts'
  }
}

export const useFetchRecommendation = () => {
  const { get } = useFetchWithDefaults()
  const baseUrl = '/v2/recommendations'

  const getAll = ({ workspaceId }: WorkspaceIdentifier) => get<Response<RecommendationData[]> & Meta>({
    url: baseUrl,
    workspaceId,
  })

  const getByDocumentId = ({
    documentId,
    workspaceId,
  }: {
    documentId: string
    workspaceId: string
  }) => get<Response<RecommendationData[]> & Meta>({
    url: `${baseUrl}/for-document/${documentId}`,
    workspaceId,
  })

  return {
    getAll,
    getByDocumentId,
  }
}
